<template>
  <div class="mx-10 ma-5">
    <v-card
      class="pa-5"
      :style="{ border: '1px solid var(--primary-boarder-color)' }"
    >
      <div>
        <PageTitleWithSearch
          :title="'Employer'"
          :btnName="' Add New User'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/employers/create'"
          :btnPermission="'customer.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        >
        </PageTitleWithSearch>
        <v-data-table
          v-if="employers"
          :headers="headers"
          :items="employers"
          :items-per-page="5"
          :hide-default-footer="true"
          :disable-sort="true"
          :disable-pagination="true"
          id="data-table"
        >
          <template v-slot:item="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td>{{ item.employer_no }}</td>
              <td class="text-left">{{ item.full_name }}</td>
              <td class="text-left">{{ item.city }}</td>
              <td class="text-left">
                {{ item.email }}
              </td>
              <td class="text-center" v-if="item.status">
                <v-chip
                  small
                  class="ma-2"
                  dark
                  :color="getStatusColor(item.status).chip"
                  :text-color="getStatusColor(item.status).text"
                >
                  {{ stringFormatting(item.status) }}
                </v-chip>
              </td>
              <td class="text-center">
                <v-btn
                  v-if="canCreateEdit()"
                  class="mx-2"
                  color="#FFE0B2"
                  :to="'/employers/edit/' + item.uuid"
                  fab
                  small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800"> mdi-pencil </v-icon>
                </v-btn>
                <v-btn
                  v-if="canDrop()"
                  class="mx-2"
                  small
                  color="#FFCDD2"
                  @click="dropMemberConfirm(item.uuid)"
                  fab
                  style="box-shadow: none;"
                >
                  <v-icon dark small color="#F44336">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <v-row class="my-1">
        <Pagination
          v-model="page"
          :loading="loading"
          :total="total"
          :page="page"
        ></Pagination>
      </v-row>
    </v-card>

    <ConfirmModal
      :text="'Do you want to drop this employer?'"
      :title="'Drop Employer'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Pagination from "@/components/shared/Pagination";
import Snackbars from "@/components/shared/Snackbars";
import { EmployerService } from "@/services/employer-service.js";
import { checkError } from "@/config/errors.js";
import { getActiveStatusColors } from "@/utility/statusColors.js";

export default {
  name: "CustomerGrid",
  components: { PageTitleWithSearch, Pagination, ConfirmModal, Snackbars },
  data: function() {
    return {
      employers: [],
      page: 1,
      search: "",
      loading: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      totalCustomer: 0,
      dropId: null,
      confirmOpen: false,
      snackbar: false,
      successMsg: "This client has incomplete jobs. Can not delete",
      defaultImage: require("@/assets/img/avatar.svg"),
      headers: [
        { text: "User ID", value: "emp_no", align: "left" },
        { text: "Name", value: "full_name", align: "left" },
        { text: "City", value: "suburb", align: "left" },
        { text: "Email", value: "email", align: "left" },
        { text: "Status", value: "status", align: "center" },
        { text: "Actions", value: "actions", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getEmployer();
  },

  watch: {
    search() {
      this.page = 1;
      this.getEmployer();
    },
    page() {
      this.getEmployer();
    },
  },

  methods: {
    getEmployer() {
      this.loading = true;
      EmployerService.getEmployerList(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.employers = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalCustomer = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.employers = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getStatusColor(status) {
      return getActiveStatusColors(status)
    },

    searchChange(value) {
      this.search = value;
    },

    canCreateEdit() {
      if (
        this.role === "ADMINISTRATOR" ||
        this.role === "MANAGER" ||
        this.role === "USER"
      ) {
        return true;
      } else {
        return false;
      }
    },

    dropMemberConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.dropMember();
    },

    dropMember() {
      if (this.dropId) {
        this.loading = true;
        EmployerService.dropMember(this.dropId)
          .then((response) => {
            if (response.data == "Success") {
              this.loading = false;
              this.getEmployer();
            } else {
              this.loading = false;
              this.snackbar = true;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.snackbar = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    canDrop() {
      if (this.role === "ADMINISTRATOR") {
        return true;
      } else {
        return false;
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
